// extracted by mini-css-extract-plugin
export default {"add-new-btn":"CustomFilter_add-new-btn__yfZzS"};